<template>
  <div role="presentation" ref="eCheckbox" class="ag-labeled ag-label-align-right ag-checkbox ag-input-field">
    <div ref="eLabel" class="ag-input-field-label ag-label ag-hidden ag-checkbox-label"></div>
    <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
         :class="{ 'ag-checked': status === 'checked', 'ag-indeterminate': status === 'indeterminate' }"
         role="presentation" @click="toggleCheckbox">
      <input ref="eInput" class="ag-input-field-input ag-checkbox-input" type="checkbox" id="ads-table-checkbox"
             aria-label="Press Space to toggle row selection (unchecked)" tabindex="-1">
    </div>
  </div>
</template>

<script>
export default {

  mounted () {
    this.params.api.addEventListener('selectionChanged', () => {
      const rowsCount = Math.abs(this.params.api.getLastDisplayedRow() - this.params.api.getFirstDisplayedRow()) + 1
      const selectedRowsCount = (this.params.api.getSelectedRows() || []).length

      if (rowsCount === selectedRowsCount) {
        this.status = 'checked'
      } else if (selectedRowsCount !== rowsCount && selectedRowsCount !== 0) {
        this.status = 'indeterminate'
      } else {
        this.status = ''
      }
    })

    this.params.api.addEventListener('paginationChanged', () => {
      this.status = ''
    })
  },

  destroyed () {
    this.params.api.removeEventListener('selectionChanged')
    this.params.api.removeEventListener('paginationChanged')
  },


  data () {
    return {
      status: ''
    }
  },
  methods: {

    toggleCheckbox () {
      if (this.status === 'checked') {
        this.unSelectAll()
        this.status = ''
      } else {
        this.selectAll()
        this.status = 'checked'
      }
    },

    selectAll () {
      const first = this.params.api.getFirstDisplayedRow()
      const last = this.params.api.getLastDisplayedRow()

      this.params.api.forEachNode((node) => {
        if (Number(node.id) >= first && Number(node.id) <= last) {
          node.setSelected(true)
        }
      })
    },

    unSelectAll () {
      this.params.api.deselectAll()
    }

  }
}
</script>


// If you want to implement this functionality, you will need to manually handle this functionality using a custom header component. I've done it before (albeit, using Infinite Row-Model, not Server-side), but you need to keep track of a few things...

// Total list of rows currently checked.
// Has the 'check all' been selected?
// Whether to show indeterminate checkbox (some, but not all rows selected).
// When getting rows from the server, you need to see if check all button has been pressed and update that row's selection accordingly.
// I used an Angular Service to keep a central location for tracking all this information, and just relied on the header-component for displaying the checkbox.

// As you see, it is a non-trivial task, and there is no easy solution


// checkbox is not checkable
// on toggle click select/dislect all rows
// watch row selection changed
//   if (all rows selected)
set checkbooks to be checked
else
uncheck
